/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BeneficiaryRecord } from './BeneficiaryRecord';

/**
 * Class used as a request payload for a fee simulation
 */
export type OperationFeeRecord = {
    /**
     * Amount that merchant want to send
     */
    amount: number;
    beneficiary?: BeneficiaryRecord;
    /**
     * Currency of the operation
     */
    currency?: OperationFeeRecord.currency;
    /**
     * Id of a previous operation, only used for refund
     */
    originalOperationId?: string;
};

export namespace OperationFeeRecord {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
